import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}

import { computed } from 'vue'

    /* ---------------- props / emits ---------------- */

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SurveyOpenerDialog',
  props: {
    propOpened: { type: Boolean },
    propSurveyId: {}
  },
  emits: ["show-access-links", "start-survey", "close-dialog"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    /* ---------------- derived ---------------- */

    const opened = computed(() => props.propOpened)
    const surveyId = computed<number | null>(() => props.propSurveyId ?? null)

    /* ---------------- actions ---------------- */

    function showAccessLinks()
    {
        emit('show-access-links', surveyId.value)
    }

    function startSurvey()
    {
        emit('start-survey', surveyId.value)
    }

    function close()
    {
        emit('close-dialog')
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", { class: "modal-wrapper" }, [
          _createElementVNode("div", { class: "modal-dialog modal-lg modal-dialog-scrollable" }, [
            _createElementVNode("div", { class: "modal-content" }, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Opening a survey", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", { class: "modal-body" }, [
                _cache[2] || (_cache[2] = _createElementVNode("p", { class: "lead" }, " You're about to open the survey. ", -1 /* CACHED */)),
                _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _createElementVNode("table", { class: "table" }, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[1] || (_cache[1] = _createElementVNode("td", null, [
                        _createElementVNode("h5", null, "Access links"),
                        _createElementVNode("p", null, "These links will let your respondents access the survey with just one click. Why not (re)send them now?​")
                      ], -1 /* CACHED */)),
                      _createElementVNode("td", { class: "align-middle" }, [
                        _createElementVNode("button", {
                          class: "btn btn-outline-secondary btn-block text-nowrap",
                          onClick: showAccessLinks
                        }, "Access links")
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: startSurvey,
                  type: "button",
                  class: "btn btn-primary"
                }, "Open the survey"),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Cancel")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})